module.exports = __webpack_public_path__ + "static/media/Acheive10.9f127760.jpeg";